
export class AdminViewModel {

    pageNo: number;
    pageSize: number;
    searchText: string;
    sort: string;
    columnName: string;
    regionId: number;
    countryId: number;
    shippinglineId:number;
}